'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeDonationTotals = exports.fetchDonationTotals = undefined;

var _client = require('../../utils/client');

var _params = require('../../utils/params');

var _justgiving = require('./justgiving');

var _everydayhero = require('./everydayhero');

var fetchDonationTotals = exports.fetchDonationTotals = function fetchDonationTotals() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  return (0, _client.isJustGiving)() ? (0, _justgiving.fetchDonationTotals)(params) : (0, _everydayhero.fetchDonationTotals)(params);
};

var deserializeDonationTotals = exports.deserializeDonationTotals = function deserializeDonationTotals(totals, excludeOffline) {
  return (0, _client.isJustGiving)() ? (0, _justgiving.deserializeDonationTotals)(totals) : (0, _everydayhero.deserializeDonationTotals)(totals, excludeOffline);
};


//////////////////
// WEBPACK FOOTER
// ../~/supporticon/api/donation-totals/index.js
// module id = 214
// module chunks = 0